// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CodePriorAuthRequirementModel {
    'code'?: string | null;
    'priorAuthRequired'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CodePriorAuthRequirementModel>> = [
        {
            "name":     "code",
            "baseName": "code",
            "type":     "string"
        },
        {
            "name":     "priorAuthRequired",
            "baseName": "priorAuthRequired",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return CodePriorAuthRequirementModel.attributeTypeMap;
    }
}
